import React, { useEffect, useCallback } from 'react';
import { FiX } from 'react-icons/fi';

const SIZES = {
  sm: '400px',
  md: '600px',
  lg: '900px',
  xl: '95vw',
};

const Modal = ({ open, onClose, title, width = 'md', children, footer, noScroll = false }) => {
  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === 'Escape') onClose();
    },
    [onClose]
  );

  useEffect(() => {
    if (open) {
      document.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [open, handleKeyDown]);

  if (!open) return null;

  const maxW = SIZES[width] || width || SIZES.md;

  return (
    <>
      <style>{`
        @keyframes modalFadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes modalScaleIn { from { opacity: 0; transform: scale(0.95) translateY(-10px); } to { opacity: 1; transform: scale(1) translateY(0); } }
      `}</style>
      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.45)',
          backdropFilter: 'blur(4px)',
          WebkitBackdropFilter: 'blur(4px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1100,
          animation: 'modalFadeIn 0.2s ease',
          padding: '20px',
        }}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            backgroundColor: 'var(--agx-surface)',
            borderRadius: '16px',
            boxShadow: '0 12px 48px rgba(0,0,0,0.18)',
            width: '100%',
            maxWidth: maxW,
            maxHeight: '90vh',
            display: 'flex',
            flexDirection: 'column',
            animation: 'modalScaleIn 0.2s ease',
            overflow: 'hidden',
          }}
        >
          {(title || onClose) && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '16px 20px',
                borderBottom: '1px solid var(--agx-border)',
                flexShrink: 0,
              }}
            >
              <h2
                style={{
                  margin: 0,
                  fontSize: '16px',
                  fontWeight: 700,
                  color: 'var(--agx-text)',
                }}
              >
                {title}
              </h2>
              <button
                onClick={onClose}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: 'var(--agx-muted)',
                  padding: '4px',
                  display: 'flex',
                  borderRadius: '8px',
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = 'var(--agx-skeleton)')}
                onMouseLeave={(e) => (e.currentTarget.style.background = 'none')}
              >
                <FiX size={20} />
              </button>
            </div>
          )}
          <div style={{ flex: 1, overflowY: noScroll ? 'hidden' : 'auto', padding: '20px', display: 'flex', flexDirection: 'column', minHeight: 0 }}>{children}</div>
          {footer && (
            <div
              style={{
                padding: '14px 20px',
                borderTop: '1px solid var(--agx-border)',
                flexShrink: 0,
              }}
            >
              {footer}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Modal;
